module.exports = __webpack_public_path__ + "static/media/logo_vitafaz.b35d1f9f.png";